<script setup lang="ts">
import { UITag } from '@groover-dev/groover-ui'
import { storeToRefs } from 'pinia'

import BandSelect from '~/components/nav/loggedIn/contextMenu/band/bandSelect.vue'
import NavLink from '~/components/nav/NavLink.vue'
import NavLinkCharts from '~/components/nav/NavLinkCharts.vue'

import { useGrowthBook } from '~/composables/useGrowthBook'
import { useSegmentTrackCampaign } from '~/composables/useSegmentTrackCampaign'

import { useUserStore } from '~/stores/user'

type Emits = {
  close: []
}

const emit = defineEmits<Emits>()
const { trackCampaignInitiated } = useSegmentTrackCampaign()
const { isFeatureOnForGroup } = useGrowthBook()

const { grooviz: GROOVIZ, IS_AGENCY } = storeToRefs(useUserStore())
const {
  is_eligible_for_groover_plus: IS_ELIGIBLE_FOR_GROOVER_PLUS,
  IS_GROOVER_PLUS_MEMBER,
  GROOVER_PLUS_SUBSCRIBED_URL,
} = storeToRefs(useUserAgencyStore())

function handleStartACampaignClicked(): void {
  trackCampaignInitiated('header')
  close()
}

function close(): void {
  emit('close')
}
</script>

<template>
  <div class="tw-grid tw-grid-cols-1">
    <NavLink
      to="/draft/"
      class="hoverText"
      color="black"
      @click="handleStartACampaignClicked"
      >{{ $t('layout.navigation11') }}</NavLink
    >
    <NavLink
      to="/band/dashboard/"
      class="hoverText"
      color="black"
      @click="$emit('close')"
      >{{ $t('layout.navigation04') }}</NavLink
    >
    <NavLinkCharts class="hoverText" />
    <NavLink
      v-if="IS_GROOVER_PLUS_MEMBER"
      :to="GROOVER_PLUS_SUBSCRIBED_URL"
      class="hoverText tw-flex tw-h-[41px] tw-items-center tw-gap-x-2xs"
      color="accent"
    >
      {{ $t('layout.navbar.artist.planBenefitsLink') }}
    </NavLink>
    <NavLink
      v-else-if="IS_ELIGIBLE_FOR_GROOVER_PLUS"
      to="/plans/"
      class="hoverText tw-flex tw-h-[41px] tw-items-center tw-gap-x-2xs"
      color="black"
    >
      {{ $t('layout.navbar.artist.plansLinkLong') }}
      <UITag
        size="sm"
        class="tw-capitalize"
        color="accent"
        :text="$t('common.new')"
      />
    </NavLink>
    <NavLink
      to="/lp/our-services/"
      class="hoverText tw-flex tw-h-[41px] tw-items-center tw-gap-x-2xs"
      color="black"
    >
      {{ $t('layout.navbar.artist.servicesLink') }}
    </NavLink>
    <div v-if="IS_AGENCY" class="tw-grid tw-grid-cols-1 sm:tw-px-5">
      <div class="tw-my-3 tw-h-px tw-w-full tw-bg-gray-200" />
      <BandSelect @close="$emit('close')" />
      <div class="tw-my-3 tw-h-px tw-w-full tw-bg-gray-200" />
    </div>
    <span
      v-if="IS_AGENCY"
      class="tw-py-3 !tw-text-base tw-font-medium sm:tw-px-5"
    >
      {{ $t('band.RPMenu.account') }}
    </span>
    <NavLink
      class="hoverText"
      to="/agency/favorites/"
      color="black"
      @click="$emit('close')"
      >{{ $t('layout.menu.menu00') }}
    </NavLink>
    <NavLink
      to="/band/shop/"
      class="hoverText tw-flex tw-items-center tw-justify-start tw-gap-1"
      color="black"
      @click="$emit('close')"
    >
      <span class="feedbackText tw-text-black">{{
        $t('layout.navigation08', GROOVIZ)
      }}</span>
      <i class="icon-grooviz !tw-text-base tw-text-icon-discrete2" />
    </NavLink>
  </div>
</template>
